import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigAssetLoaderService } from '@icullen/api/shared';
import { Observable } from 'rxjs';
import {HomePageHeadlines, DomainPageHeadlines } from '../../model/headlines.model';

@Injectable({
  providedIn: 'root'
})
export class HeadlinesApiService {

  HEADLINES_API_BASE_URL : string;

  constructor(private httpClient: HttpClient,
     configService : ConfigAssetLoaderService) {
      this.HEADLINES_API_BASE_URL= configService.getConfig().apiBaseUrl+'site/headlines/';
  }

  getHeadlinesByService(service : string): Observable<DomainPageHeadlines> {
    return this.httpClient.get<DomainPageHeadlines>(this.HEADLINES_API_BASE_URL+'service/'+service+'?format=json');
  }

  getHeadlinesByPillar(pillar : string): Observable<DomainPageHeadlines> {
    return this.httpClient.get<DomainPageHeadlines>(this.HEADLINES_API_BASE_URL+'pillar/'+pillar+'?format=json');
  }

  getHeadlinesByDocType(service : string, docType : string): Observable<DomainPageHeadlines> {
    return this.httpClient.get<DomainPageHeadlines>(this.HEADLINES_API_BASE_URL+'service/'+service+'/documentType/'+docType+'?format=json');
  }

  getHeadlinesByRegion(service : string, region : string): Observable<DomainPageHeadlines> {
    return this.httpClient.get<DomainPageHeadlines>(this.HEADLINES_API_BASE_URL+'service/'+service+'/region/'+region+'?format=json');
  }

  getHomepageHeadlines(): Observable<HomePageHeadlines> {
    return this.httpClient.get<HomePageHeadlines>(this.HEADLINES_API_BASE_URL+'home?format=json');
  }

}
